// extracted by mini-css-extract-plugin
module.exports = {"Box":"CustomFadeBox_Box__3oD7o","Div":"CustomFadeBox_Div__3Xrib","LargeDiv":"CustomFadeBox_LargeDiv__2ljqp"};